import React from 'react';
import { useMatchMedia } from '@make-software/cspr-design';

import { ContractPackageHashFilter, NftsGrid } from '../../../components';
import { useGetPaginatedAccountTokens } from '../../../hooks/event-store-hooks';

export interface AccountNFTTokensListProps {
  accountHash: string;
}

export const AccountNFTTokensList = ({
  accountHash,
}: AccountNFTTokensListProps) => {
  const responsivePageSize = useMatchMedia([10, 20, 20, 20], []);

  const { data, loading, error, paginationProps, sortingProps, filterProps } =
    useGetPaginatedAccountTokens({
      hash: accountHash,
      includes: 'contract_package',
      is_burned: false,
      defaultPageSize: responsivePageSize,
    });

  return (
    <NftsGrid
      tableId="accountNftTokens"
      data={data}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
      sortingProps={sortingProps}
      filter={<ContractPackageHashFilter {...filterProps} />}
      showContractPackageInfo
    />
  );
};

export default AccountNFTTokensList;
